import PropTypes from 'prop-types';

import VisibilityToggle from 'shared/components/VisibilityToggle';
import { formatDateTime, formatMonthDayTime } from 'shared/utils/dateUtils';
import { getText } from 'shared/utils/Text';

import HelpButton from '../../button/HelpButton';
import Locked from '../../icon/Locked';
import Unlocked from '../../icon/Unlocked';
import CheckboxInput from '../../input/CheckboxInput';
import BetHeaderButton from '../BetHeaderButton';
import BetHeaderItem from '../BetHeaderItem';
import BetHeaderPopup from '../BetHeaderPopup';
import styles from './styles.module.scss';

const LockButton = ({ isLocked, enabled, lockTime, onChange }) => (
  <VisibilityToggle
    render={({ visible, onToggleClick, insideRefHandler }) => (
      <BetHeaderItem className={styles.lockButton}>
        <BetHeaderButton
          showExpandIcon={false}
          onClick={onToggleClick}
          buttonRef={insideRefHandler}
          disabled={!enabled}
        >
          <div className={styles.wrapperLock}>
            <div className={styles.lock}>
              <span className={styles.text}>
                {getText(isLocked ? 'button-locked' : 'button-unlocked')}
              </span>
              <span
                title={
                  isLocked
                    ? getText('lock-locktime', formatDateTime(lockTime))
                    : undefined
                }
              >
                {isLocked && <Locked />}
                {!isLocked && <Unlocked />}
              </span>
            </div>
            {isLocked && (
              <div className={styles.date}>{formatMonthDayTime(lockTime)}</div>
            )}
          </div>
        </BetHeaderButton>

        <BetHeaderPopup
          className={styles.lockPopup}
          visible={visible && enabled}
          refHandler={insideRefHandler}
        >
          <div className={styles.lockPopupInner}>
            <CheckboxInput
              className={styles.lockCheckInput}
              small
              onChange={() => {
                onChange();
                onToggleClick();
              }}
              checked={isLocked}
              colorFill
              labelText={
                isLocked
                  ? `${getText('lock-popup-unlock')} ${
                      lockTime
                        ? getText(
                            'lock-popup-locktime',
                            formatDateTime(lockTime),
                          )
                        : ''
                    }`
                  : getText('lock-popup-lock')
              }
            />
            {isLocked && (
              <HelpButton
                header={getText('help-config-locked-header')}
                body={getText('help-config-locked-body')}
              />
            )}
          </div>
        </BetHeaderPopup>
      </BetHeaderItem>
    )}
  />
);

LockButton.propTypes = {
  isLocked: PropTypes.bool.isRequired,
  enabled: PropTypes.bool.isRequired,
  lockTime: PropTypes.number,
  onChange: PropTypes.func.isRequired,
};

export default LockButton;
